import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const WidgetContainer = styled.div`
  background-color: ${customPalette.accent.white};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  margin-right: 24px;

  h3 {
    font-size: 16px;
    font-weight: 700;
    color: ${customPalette.grey.main};
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
`;

export const UnreadCount = styled.div`
  background-color: #ef7c01;
  color: ${customPalette.accent.white};
  padding: 0 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
`;

export const DocumentItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  a {
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const DocumentLink = styled.div`
  display: flex;
  align-items: center;
  color: ${customPalette.accent.main};

  span {
    margin-left: 8px;
  }

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const ActionButtonContainer = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: flex-start;
`;

export const IconWrapper = styled.div`
  svg {
    margin-right: 8px;
    width: 24px;
    height: 24px;
  }
`;
